var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"app__header"},[_c('router-link',{staticClass:"app__header__logo",attrs:{"to":`/${_vm.organization.id}`}},[_c('img',{attrs:{"alt":`${_vm.organization.brand.name} logo`,"src":_vm.organization.brand.logo}})]),(_vm.organization.id)?_c('h1',[_vm._v(_vm._s(_vm.organization.brand.name))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }